/**
 * Infinite - Auto load content on scroll
 * Copyright (c) 2011, 2020, 2021, 2022, 2023 Hiltonian Media Ltd, www.hiltonian.com
 * Use not permitted without written permission
 * Date: 06/04/2023
 * @author Richard Rutherford Hilton
 * @version 3.0.0
 */

function infiniteScroll(containers, contentSelector, opts) {

	// Quit if IntersectionObserver is not available
	if (!('IntersectionObserver' in window)) return;

	const defaults = {
		contentSelector: contentSelector, 
		paginator: 'ul.selector',
		nextLink: 'ul.selector .next a',
		loading: '<p class="autoload-loading">Loading</p>',
		more: '<p class="autoload-more"><a href="#">Load More...</a></p>',
		sequence: [true], // Each element in the array indicates whether the load should be automatic or manual, e.g. [true, true, true, false] for three autoloads followed by a manual load (then repeats)
		onload: function () {},
		clearCache: 3,
	}

	const settings = {...defaults, ...opts};

	// Get the element
	if (typeof containers === 'string') containers = document.querySelectorAll(containers);
	if (containers && typeof containers[Symbol.iterator] !== 'function') containers = [containers];
	if (!containers || typeof containers !== 'object' || !containers.length) return;

	// Clear old values from session storage
	var keys = [];
	for (const key in sessionStorage) {
		var matches = key.match(/autoload_cache_([0-9]+)(.+)/);
		if (!matches) continue;
		keys.push({
			t: matches[1],
			r: matches[2],
		});
	}
	keys.sort((a, b) => parseInt(a.t) - parseInt(b.r)).reverse().forEach((key, index) => {
		if (index < keys.length - settings.clearCache) {
			sessionStorage.removeItem('autoload_cache_' + key.t + key.r);
		}
	});
		
	const getNextLink = function(el) {
		const next = el.querySelector(settings.nextLink);
		if (next && next.href !== '#') {
			return next.href;
		} else {
			return false;
		}
	}
		
	const createElementFromHtml = html => {
		const template = document.createElement('template');
		template.innerHTML = html.trim();
		return template.content.firstChild;
	}

	const nextIsAuto = function(pages_loaded) {
		return !Array.isArray(settings.sequence) 
			|| settings.sequence.length == 0 
			|| settings.sequence[pages_loaded % settings.sequence.length];
	}

	const isVisible = el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	
	containers.forEach(container => {
		const content = container.querySelector(settings.contentSelector);
		if (!content) return;

		var pages_loaded = 0; // Keeps track of how many *extra* pages have been autoloaded
		var key = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
		var observedElement = null;
		var firstPageCache = content.innerHTML;

		const observer = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting) {
				loadNext();
				observer.unobserve(entries[0].target);
			}
		});

		var next = getNextLink(container);
		
		const loading = createElementFromHtml(settings.loading);
		const more = createElementFromHtml(settings.more);
		
		container.querySelectorAll(settings.paginator).forEach(el => {
			el.hidden = true;
		});
		
		if (next) {
			content.after(loading);
			content.after(more);
		}

		const loadNext = function() {
			if (next) {
				try {
					fetch(next).then(response => response.text()).then(body => {
						const parser = new DOMParser();
						const doc = parser.parseFromString(body, 'text/html');
						next = getNextLink(doc);
						updateContent(doc);
					});
				} catch (error) {
					switchAutoOff();
				}
			} else {
				switchAutoOff();
			}
		}

		more.addEventListener('click', event => {
			loadNext();
			event.preventDefault();
		});

		const switchAutoOff = function() {
			if (observedElement) observer.unobserve(observedElement);
			loading.hidden = true;
			if (next) {
				more.hidden = false;
				more.href = next;
			} else {
				more.hidden = true;
			}
		}

		const switchAutoOn = function() {
			more.hidden = true;
			if (next) {
				loading.hidden = false;
				observedElement = Array.from(content.children).findLast(isVisible);
				if (observedElement) observer.observe(observedElement);
			} else {
				loading.hidden = true;
			}
		}

		const initContent = function(html) {
			content.innerHTML = html;
			settings.onload(content.children, true);

			if (nextIsAuto(pages_loaded)) { 
				switchAutoOn();
			} else {
				switchAutoOff();
			}
		}

		const updateContent = function(newPage, init) {
			// Update the content
			const newContent = newPage.querySelector(settings.contentSelector);
			if (!newContent) return;
			const newChildren = newContent.children;
			
			// Make sure users can (smoothly) return to the page
			if (window.history && typeof(Storage) !== "undefined") {
				pages_loaded++;
				history.replaceState({
					key: key,
					next: next,
					pages: pages_loaded
				}, '');
				try {
					const oldCacheContent = sessionStorage.getItem('autoload_cache_' + history.state.key) || firstPageCache;
					sessionStorage.setItem('autoload_cache_' + key, oldCacheContent + newContent.innerHTML);
				} catch (e) {
					// Session storage full
				}
			}

			content.append(...newChildren);
			settings.onload(newChildren, false);

			if (nextIsAuto(pages_loaded)) { 
				switchAutoOn();
			} else {
				switchAutoOff();
			}
		};

		// Deal with back/forward button clicks
		if (window.history && history.state && history.state.key && typeof(Storage) !== "undefined") {
			var cachedContent = sessionStorage.getItem('autoload_cache_' + history.state.key);
			if (cachedContent && cachedContent.length) {
				key = history.state.key;
				next = history.state.next;
				pages_loaded = history.state.pages || 0;
				if (pages_loaded > 0) initContent(cachedContent);
			}
		}

		if (nextIsAuto(pages_loaded)) {
			switchAutoOn();
		} else {
			switchAutoOff();
		}
	});
};